var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuitcase = function SvgSuitcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#212529",
    clipPath: "url(#suitcase_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.582 7c-.276 0-.5.276-.5.615v6.77c0 .34.224.615.5.615.277 0 .5-.276.5-.615v-6.77c0-.34-.223-.615-.5-.615M7.5 7c-.277 0-.5.276-.5.615v6.77c0 .34.223.615.5.615s.5-.276.5-.615v-6.77C8 7.275 7.777 7 7.5 7M11.582 7c-.277 0-.5.276-.5.615v6.77c0 .34.223.615.5.615.276 0 .5-.276.5-.615v-6.77c0-.34-.224-.615-.5-.615"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.833 3.334h-.65v-2C12.183.598 11.6 0 10.883 0h-2.6c-.717 0-1.3.598-1.3 1.334v2h-.65c-1.792 0-3.25 1.495-3.25 3.333v8.667c0 1.609 1.119 2.956 2.6 3.266v.734c0 .368.29.666.65.666s.65-.298.65-.666v-.667h5.2v.667c0 .368.29.666.65.666s.65-.298.65-.666V18.6c1.481-.31 2.6-1.656 2.6-3.266V6.667c0-1.838-1.458-3.333-3.25-3.333m-4.55-2h2.6v2h-2.6zm6.5 14c0 1.102-.875 2-1.95 2h-6.5c-1.075 0-1.95-.898-1.95-2V6.667c0-1.103.875-2 1.95-2h6.5c1.075 0 1.95.897 1.95 2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "suitcase_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgSuitcase;